import React from 'react'

const AboutTitle = () => {
    return (
        <div>
  <div className="breadcrumb-banner-area bread-banner">
    <div className="container">
      <div className="row-breadcrumb">
        <div className="col-md-12">
          <div className="breadcrumb-text text-center">

            <h2>About Us</h2>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="aboutus" className="container">
    <div className="row">

      <div className="col-sm-12 col-md-6 align-self-center">
        <div>
          <h4><b>
              Welcome to Techarabiya. </b>
            Thanks for taking the time to see all the great things that Techarabiya has to offer.

          </h4>
          <br />
          <p>Techarabiya is a new technology company founded by industry professionals with strong passion towards
            Fintech Solutions and Digital Transformation. We have not only established an innovative business model
            focusing on digital & Fintech solutions, but also offers a range of products and services to support our
            customers and creating values. </p>
          <p>We are a group of passionate innovators and entrepreneurs with a proven track record. Our strengths are
            derived from our proven ability to leverage our most valuable assets — our people, our technology, our
            development capabilities and our unrelenting focus on creating value for our customers.</p>
          <p>At Techarabiya, we take a pride and determination to deliver the very best for all our stakeholders. We
            continue to believe that our products, services and the value they add to our customers' businesses, remains
            the fundamental elements of our continued success.</p>
          <p>
            <hr />
            <b>Akif M Shaikh</b>
            <br />
            Founder & Chief Executive Officer

          </p>

          <br />

        </div>
      </div>
      <div className="col-sm-12 col-md-6">
        <img src="./img/ceo.png" className="img-fluid a-img-1" />

      </div>
    </div>

  </div>
  <div>
  <div className="container-fluid" style={{backgroundColor: '#101a84'}}>
    <div id="aboutus" className="container">
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <img src="./img/header_img.png" className="img-fluid a-img-2" />
        </div>
        <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 align-self-center">
          <div className="text-aboutus">
            <h4><b>“We transform brands by developing a competitive edge in this era of digital transformation.”  
              </b></h4>
            <br />
            <p>Techarabiya is a fast-growing “Software House” that proudly deals in Fintech and Digital Solutions. Techarabiya believes in “Transforming Lives” through Digital and Fintech solutions.</p>
            <p>Techarabiya knows its craft and successfully merges expertise, experience and innovation to deliver high-value results.  We know what it takes to develop a strong image in this field and thus, Techarabiya is a true and collegial partner to develop mesmerizing &amp; authentic digital experiences. </p>
            <p>Our aim is to combine fun and experience together, in order to deal with challenges and further, turn them into opportunities. We connect to people and ideas in a way to do just the right thing for our clients, people and communities. 
            </p>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* About Begin */}
  <section>
    <div className="container">
      <br /><br />
      <div className="row align-items-center mb-5">
        <div className="col-lg-6">
          {/* About Tabs Begin */}
          <div className="about-nav-tab">
            {/* Nav Tabs Begin */}
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-items">
                <a className="nav-link active" data-toggle="tab" href="#mission" role="tab" aria-selected="true"><h4>Our Mission</h4></a>
              </li>
              <li className="nav-items">
                <a className="nav-link" data-toggle="tab" href="#vission" role="tab" aria-selected="false"><h4>Our Vision</h4></a>
              </li>
            </ul>
            {/* Nav Tabs End */}
            {/* Tab Contents Begin */}
            <div className="tab-content">
              {/* Mission Tab Begin */}
              <div className="tab-pane fade show active" id="mission" role="tabpanel">
                <br />
                <p>Thinking out of box, delivering high-quality technology solutions, working with companies in digital transformation and setting example of collaboration and teamwork to have a transformative impact. We strive to make technology work for our people, customers and clients by giving simple but powerful products. </p>
              </div>
              {/* Mission Tab End */}
              {/* Vission Tab Begin */}
              <div className="tab-pane fade" id="vission" role="tabpanel">
                <br />
                <p>Our Vision is to build a leading Technology company and a most preferred partner who is Innovative, Agile &amp; Trustworthy offering smart solutions and be a backbone of digitization and fintech innovation. We strive to make technology work for our people, customers and clients by giving simple but powerful products.</p>
              </div>
              {/* Vission Tab End */}
            </div>
            {/* Tab Contents End */}
          </div>
          {/* About Tabs End */}
        </div>
        <div className="col-lg-6">
          <img src="./img/Website_EPV_AdvancedSalesConcepts-1.png" className="img-fluid a-img-3" />
        </div>
      </div>
    </div>
  </section>
</div>
 

</div>
     
    )
}

export default AboutTitle
